import React from 'react';

const VMExecutionLesson = ({ onBack }) => {
  const openPlayground = () => {
    window.open('https://playground.miden.xyz', '_blank');
  };

  return (
    <section className="playground-page">
      <div className="game-header">
        <button onClick={onBack} className="back-button">
          ← Back to Playground
        </button>
      </div>

      <div className="lesson-page">
        <h2>Private Payment · Micro‑Lesson</h2>
        <p className="lesson-intro">
          Follow a simple private payment story, then hop into the official Miden Playground to see how
          a payment program looks in real Miden Assembly.
        </p>

        <div className="lesson-content">
          <h3>Story: Sending a Private Tip</h3>
          <ul className="lesson-list">
            <li>
              You send a tip to a creator. The network must be sure the tip is valid, but you do not
              want everyone to see all your balances and history.
            </li>
            <li>
              Your wallet creates a private receipt: a proof that "this payment follows the rules"
              without exposing every detail.
            </li>
            <li>
              The verifier checks the proof instead of replaying all raw data, so the chain learns
              "this is valid" but not your full story.
            </li>
            <li>
              This is what "invisible math" does: it proves correctness while hiding sensitive inputs.
            </li>
            <li>
              In Miden, this all runs inside the VM; the Playground lets you see a small version of
              that process in code.
            </li>
          </ul>
        </div>

        <div className="lesson-actions">
          <button className="activity-button" onClick={openPlayground}>
            Open official Miden Playground
          </button>
          <p className="lesson-footnote">
            For developers: in the Playground, start with a simple example program and try changing
            inputs to see how outputs and traces react.
          </p>
        </div>
      </div>
    </section>
  );
};

export default VMExecutionLesson;

